import { createContext } from 'react';
export const PwaContext = createContext(null);
